import React, { useEffect, useState } from "react";
import { domain } from "../../assets/js/api";
import parse from "html-react-parser";
import { getImageSize } from "react-image-size";
import iconMes from "../../assets/img/ico-mes.svg";
import iconMenys from "../../assets/img/ico-menys.svg";
import { useLocation } from "react-router-dom";

const SectionWhite = ({ year, section, id }) => {
  const [image, setImage] = useState(null);
  const [titolYear, setTitolYear] = useState(null);
  const [tab, setTab] = useState(0);
  const [popup, setPopup] = useState(false);
  const location = useLocation();

  const dynamicImport = async () => {
    try {
      if (year.term) {
        const module = await import(`../../assets/img/${year.term}.svg`);
        setTitolYear(module.default);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    const hash = location.hash;
    if (hash && hash == `#${id}`) {
      const targetElement = document.getElementById(id);
      if (targetElement) {
        targetElement.scrollIntoView({ behavior: "smooth", block: 'start' });
      }
    }
  }, [location, id]);

  useEffect(() => {
    if (tab === 1 && year.image2) {
      getImageSize(domain + year.image2.image).then((res) => {
        year.image2.isWide = res.width > res.height;
        setImage(year.image2);
      });
    } else if (year.image) {
      getImageSize(domain + year.image.image).then((res) => {
        year.image.isWide = res.width > res.height;
        setImage(year.image);
      });
    }
    dynamicImport();
  }, [tab, year.image, year.image2]);

  const changeTab = (index) => {
    setTab(index);
  };

  return (
    <div
      id={id ? id : ""}
      className={
        section
          ? " section section-expo has-background-white"
          : "section has-background-white"
      }
    >
      <div className="wrapper is-relative">
        <div className="columns is-desktop is-variable is-8">
          <div className="column is-one-third-widescreen flow--l">
            <h2>
              <img
                src={titolYear}
                alt={year.title}
                width="216"
                height="89"
                className="year"
              />
            </h2>
            {image ? (
              <figure
                className={
                  "is-hidden-desktop " +
                  (image.isWide ? "is-landscape" : "is-portrait")
                }
              >
                <img
                  loading="lazy"
                  src={domain + image.image}
                  width="400"
                  height="500"
                  alt=""
                />
                <figcaption>{image.footprint}</figcaption>
              </figure>
            ) : (
              ""
            )}
            {year.body.length === 1 ? (
              <div className="flow">
                {parse(year.body[0])}
                {year.childrens.length > 0 ? (
                  <div className="has-text-centered is-hidden-desktop">
                    <button
                      type="button"
                      onClick={() => setPopup(!popup)}
                      className="popup-btn is-size-3 has-text-weight-bold"
                      aria-controls="popup"
                      aria-expanded={popup}
                    >
                      {year.childrens[0].term}
                      {!popup ? (
                        <img src={iconMes} alt="" width="25" height="25" />
                      ) : (
                        <img src={iconMenys} alt="" width="25" height="25" />
                      )}
                    </button>
                  </div>
                ) : (
                  ""
                )}
              </div>
            ) : (
              <div className="tabs-wrapper flow">
                <ul role="tablist" className="tablist is-flex gap-3 is-size-6">
                  {year.body.map((text, index) => (
                    <li role="presentation">
                      <button
                        role="tab"
                        id={index + "-Tab"}
                        onClick={() => changeTab(index)}
                        aria-selected={tab === index ? "true" : "false"}
                        aria-controls={index + "-TabPanel"}
                        tabIndex={index}
                        className="is-flex gap-1 is-align-items-center p-3 has-text-weight-bold"
                      >
                        {year.term}/{index + 1}
                      </button>
                    </li>
                  ))}
                </ul>
                {year.body.map((text, index) => (
                  <div
                    role="tabpanel"
                    id={index + "-TabPanel"}
                    aria-hidden={tab !== index ? "true" : "false"}
                    aria-labelledby={index + "-Tab"}
                    tabIndex="{index}"
                    className="flow"
                  >
                    {parse(text)}
                  </div>
                ))}
              </div>
            )}
          </div>
          <div className="column is-hidden-touch">
            {image ? (
              <figure className={image.isWide ? "is-landscape" : "is-portrait"}>
                <img loading="lazy" src={domain + image.image} alt="" />
                <figcaption>
                  {image.footprint}
                  {year.childrens.length > 0 ? (
                    <button
                      onClick={() => setPopup(!popup)}
                      type="button"
                      className="popup-btn is-size-3 has-text-weight-bold"
                      aria-controls="popup"
                      aria-expanded="false"
                    >
                      {year.childrens[0].term}
                      {!popup ? (
                        <img src={iconMes} width="25" height="25" />
                      ) : (
                        <img src={iconMenys} width="25" height="25" />
                      )}
                    </button>
                  ) : (
                    ""
                  )}
                </figcaption>
              </figure>
            ) : (
              ""
            )}
          </div>
        </div>
        {popup && year.childrens.length > 0 ? (
          <div
            id="popup"
            className="popup is-relative has-background-primary has-text-white p-7"
          >
            <h3 className="is-size-2 has-text-weight-bold mb-4">
              {year.childrens[0].term}
            </h3>
            <div className="columns is-multiline has-text-weight-bold">
              {parse(year.childrens[0].body)}
            </div>
            <button
              type="button"
              onClick={() => setPopup(false)}
              aria-controls="popup"
              aria-expanded="true"
            >
              <img src={iconMenys} width="25" height="25" />
            </button>
          </div>
        ) : (
          ""
        )}
      </div>
    </div>
  );
};
export default SectionWhite;
